import {
  chatbotV2Service,
  type ChannelAccountStatus,
  type ChannelOAuthOption,
  type ChannelOAuthPreviewResult,
  type ChatChannel,
} from "../../../services/chatbotV2/chatbotV2Service";
import { whatsappOAuthCallback } from "../../../services/whatsapp/whatsappService";
import { decodeTokenService } from "../../../services/decodeTokenService";
import { getLocalOwnerIdOverride } from "../../../services/instance";

const resolveOwnerId = () =>
  getLocalOwnerIdOverride() || decodeTokenService.getUserIdFromToken() || "";

const getMetaOAuthRedirectUri = () =>
  typeof window === "undefined" ? undefined : `${window.location.origin}/integrations`;

export const completeWhatsAppOAuth = async (data: {
  code: string;
  phone_number_id: string;
  waba_id: string;
}) => {
  const owner_id = resolveOwnerId();
  if (!owner_id) {
    throw new Error("No se pudo resolver el owner_id para completar OAuth de WhatsApp");
  }
  return whatsappOAuthCallback({
    code: data.code,
    phone_number_id: data.phone_number_id,
    waba_id: data.waba_id,
    owner_id,
  });
};

export const previewChannelOAuth = async (
  channel: ChatChannel,
  code: string
): Promise<ChannelOAuthPreviewResult> =>
  chatbotV2Service.channelOAuthPreview(channel, {
    code,
    redirect_uri: getMetaOAuthRedirectUri(),
  });

export const completeChannelOAuth = async (
  channel: ChatChannel,
  code: string,
  options?: ChannelOAuthOption[]
): Promise<ChannelAccountStatus> => {
  const preview = await chatbotV2Service.channelOAuthPreview(channel, {
    code,
    redirect_uri: getMetaOAuthRedirectUri(),
  });
  if (!preview.selection_required) {
    if (preview.account) return preview.account;
    throw new Error("OAuth preview completed without account payload");
  }

  const sessionId = preview.oauth_session_id;
  const available = preview.options?.length ? preview.options : options;
  if (!sessionId || !available?.length) {
    throw new Error("OAuth selection required but no options were returned");
  }

  const selected = available.length === 1 ? available[0] : null;
  if (!selected) {
    throw new Error("selection_required");
  }

  return chatbotV2Service.channelOAuthCallback(channel, {
    oauth_session_id: sessionId,
    page_id: selected.page_id,
    page_name: selected.page_name,
    instagram_business_account_id: selected.instagram_business_account_id,
  });
};

export const completeChannelOAuthWithSelection = async (
  channel: ChatChannel,
  oauthSessionId: string,
  option: ChannelOAuthOption
): Promise<ChannelAccountStatus> =>
  chatbotV2Service.channelOAuthCallback(channel, {
    oauth_session_id: oauthSessionId,
    page_id: option.page_id,
    page_name: option.page_name,
    instagram_business_account_id: option.instagram_business_account_id,
  });
